export type ReceivedProps = Record<string, any>;

const useHistory = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useHistory>;

export default useHistory;
